// removed by extract-text-webpack-plugin
module.exports = {"userNavItemAccountName":"UserNavItem__userNavItemAccountName___2ohQ1","inner":"UserNavItem__inner___30cPi","userNavItemOuter":"UserNavItem__userNavItemOuter___2ijHT","userNavItem":"UserNavItem__userNavItem___2hZ31","popover":"UserNavItem__popover___1qW5G","popoverItem":"UserNavItem__popoverItem___1sIVF","popoverItemIcon":"UserNavItem__popoverItemIcon___KkoXD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/UserNavItem/UserNavItem.scss
// module id = 645
// module chunks = 0